// extracted by mini-css-extract-plugin
export default {"label":"Search_label__sqIjp","icon":"Search_icon__dqUQ5","input":"Search_input__ng35J"};